export default {
	add(form, cb, ecb, config) {
		this.http
			.post('/review/create/', form, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getByTarget(id, type, params, cb) {
		this.http
			.get('/review/getByTarget/' + id + '/' + type, {
				params: params
			})
			.then((r) => cb && cb(r))
	},
	summary(id, type, cb) {
		this.http
			.get('/review/summary/' + id + '/' + type, {})
			.then((r) => cb && cb(r))
	}
}
